var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bet_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 25 25",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".bet_svg__st0{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linejoin:round}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bet_svg__Icon_-_Bet",
    transform: "translate(.031 .031)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "bet_svg__Ellipse_60",
    className: "bet_svg__st0",
    cx: 12.5,
    cy: 12.5,
    r: 11.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "bet_svg__Ellipse_61",
    className: "bet_svg__st0",
    cx: 12.5,
    cy: 12.5,
    r: 7.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet_svg__Line_114",
    className: "bet_svg__st0",
    d: "M10.3 1.2l.7 3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet_svg__Line_115",
    className: "bet_svg__st0",
    d: "M13.8 4.9l.7-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet_svg__Line_116",
    className: "bet_svg__st0",
    d: "M1.6 8.7L5.2 10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet_svg__Line_117",
    className: "bet_svg__st0",
    d: "M6.5 7.6l-3-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet_svg__Line_118",
    className: "bet_svg__st0",
    d: "M3.6 20l2.9-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet_svg__Line_119",
    className: "bet_svg__st0",
    d: "M5.2 15l-3.6 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet_svg__Line_120",
    className: "bet_svg__st0",
    d: "M14.6 23.8l-.7-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet_svg__Line_121",
    className: "bet_svg__st0",
    d: "M11.1 20l-.7 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet_svg__Line_122",
    className: "bet_svg__st0",
    d: "M23.4 16.2l-3.7-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet_svg__Line_123",
    className: "bet_svg__st0",
    d: "M18.5 17.4l2.9 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet_svg__Line_124",
    className: "bet_svg__st0",
    d: "M21.3 5l-2.9 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet_svg__Line_125",
    className: "bet_svg__st0",
    d: "M19.7 9.9l3.6-1.3"
  }))));
}
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyNSAyNSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjUgMjU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTpjdXJyZW50Q29sb3I7c3Ryb2tlLXdpZHRoOjEuNTtzdHJva2UtbGluZWpvaW46cm91bmQ7fQo8L3N0eWxlPgo8ZyBpZD0iSWNvbl8tX0JldCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMzEgMC4wMzEpIj4KCTxjaXJjbGUgaWQ9IkVsbGlwc2VfNjAiIGNsYXNzPSJzdDAiIGN4PSIxMi41IiBjeT0iMTIuNSIgcj0iMTEuNSIvPgoJPGNpcmNsZSBpZD0iRWxsaXBzZV82MSIgY2xhc3M9InN0MCIgY3g9IjEyLjUiIGN5PSIxMi41IiByPSI3LjYiLz4KCTxsaW5lIGlkPSJMaW5lXzExNCIgY2xhc3M9InN0MCIgeDE9IjEwLjMiIHkxPSIxLjIiIHgyPSIxMSIgeTI9IjQuOSIvPgoJPGxpbmUgaWQ9IkxpbmVfMTE1IiBjbGFzcz0ic3QwIiB4MT0iMTMuOCIgeTE9IjQuOSIgeDI9IjE0LjUiIHkyPSIxLjEiLz4KCTxsaW5lIGlkPSJMaW5lXzExNiIgY2xhc3M9InN0MCIgeDE9IjEuNiIgeTE9IjguNyIgeDI9IjUuMiIgeTI9IjEwIi8+Cgk8bGluZSBpZD0iTGluZV8xMTciIGNsYXNzPSJzdDAiIHgxPSI2LjUiIHkxPSI3LjYiIHgyPSIzLjUiIHkyPSI1LjEiLz4KCTxsaW5lIGlkPSJMaW5lXzExOCIgY2xhc3M9InN0MCIgeDE9IjMuNiIgeTE9IjIwIiB4Mj0iNi41IiB5Mj0iMTcuNCIvPgoJPGxpbmUgaWQ9IkxpbmVfMTE5IiBjbGFzcz0ic3QwIiB4MT0iNS4yIiB5MT0iMTUiIHgyPSIxLjYiIHkyPSIxNi4zIi8+Cgk8bGluZSBpZD0iTGluZV8xMjAiIGNsYXNzPSJzdDAiIHgxPSIxNC42IiB5MT0iMjMuOCIgeDI9IjEzLjkiIHkyPSIyMCIvPgoJPGxpbmUgaWQ9IkxpbmVfMTIxIiBjbGFzcz0ic3QwIiB4MT0iMTEuMSIgeTE9IjIwIiB4Mj0iMTAuNCIgeTI9IjIzLjgiLz4KCTxsaW5lIGlkPSJMaW5lXzEyMiIgY2xhc3M9InN0MCIgeDE9IjIzLjQiIHkxPSIxNi4yIiB4Mj0iMTkuNyIgeTI9IjE0LjkiLz4KCTxsaW5lIGlkPSJMaW5lXzEyMyIgY2xhc3M9InN0MCIgeDE9IjE4LjUiIHkxPSIxNy40IiB4Mj0iMjEuNCIgeTI9IjE5LjkiLz4KCTxsaW5lIGlkPSJMaW5lXzEyNCIgY2xhc3M9InN0MCIgeDE9IjIxLjMiIHkxPSI1IiB4Mj0iMTguNCIgeTI9IjcuNSIvPgoJPGxpbmUgaWQ9IkxpbmVfMTI1IiBjbGFzcz0ic3QwIiB4MT0iMTkuNyIgeTE9IjkuOSIgeDI9IjIzLjMiIHkyPSI4LjYiLz4KPC9nPgo8L3N2Zz4K";
export { SvgBet as ReactComponent };